export default __webpack_public_path__ + "static/media/abstracto-plus-logo.72894af2.svg";